var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9059 4.3691C17.2301 4.3691 17.5 4.63826 17.5 4.98076V5.29742C17.5 5.63159 17.2301 5.90908 16.9059 5.90908H3.09488C2.76988 5.90908 2.5 5.63159 2.5 5.29742V4.98076C2.5 4.63826 2.76988 4.3691 3.09488 4.3691H5.52464C6.01821 4.3691 6.44775 4.01827 6.55879 3.52327L6.68603 2.95495C6.88378 2.18079 7.53458 1.66663 8.27939 1.66663H11.7206C12.4573 1.66663 13.1154 2.18079 13.3059 2.91411L13.442 3.52244C13.5522 4.01827 13.9818 4.3691 14.4762 4.3691H16.9059ZM15.6715 15.945C15.9252 13.5809 16.3694 7.96428 16.3694 7.90761C16.3856 7.73595 16.3296 7.57345 16.2186 7.44262C16.0995 7.32012 15.9487 7.24762 15.7826 7.24762H4.22379C4.05684 7.24762 3.89799 7.32012 3.78776 7.44262C3.67592 7.57345 3.62081 7.73595 3.62891 7.90761C3.6304 7.91803 3.64634 8.11587 3.67298 8.44662C3.79134 9.91599 4.121 14.0085 4.33401 15.945C4.48476 17.3717 5.42084 18.2683 6.77674 18.3008C7.82305 18.325 8.90096 18.3333 10.0032 18.3333C11.0414 18.3333 12.0958 18.325 13.1745 18.3008C14.5774 18.2767 15.5127 17.3959 15.6715 15.945Z",
    fill: "#CF3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bc120d2be5d012cc0311adc531e4da64.svg";
export { ForwardRef as ReactComponent };